import { createApiRef } from '@backstage/core-plugin-api';
import { MlflowModelSummary } from '@internal/plugin-mlflow-common';

export interface MlflowApi {
  getModelSummary(modelName: string, cluster?: string): Promise<MlflowModelSummary>;
  promote(
    modelName: string,
    alias: string,
    version: string,
    cluster?: string,
  ): Promise<MlflowModelSummary>;
}

export const mlflowApiRef = createApiRef<MlflowApi>({
  id: 'plugin.mlflow.service',
});
